import { Text } from 'styles/themeColors';
import { capitalize, currencySign, formatDateTime } from '../../utils/formatters';
import { LegacyColumn as Column } from 'components/MaterialTable/MatDataGridTypes';

const getServiceTableColumns = (countries: any): Column<any>[] => {
  // Base columns
  const baseColumns: Column<any>[] = [
    {
      title: 'SKU',
      field: 'sku',
      headerStyle: { color: Text.primary },
      width: '200px',
      sorting: true,
      render: (rowData) => capitalize(rowData.sku, 'N/A'),
      cellStyle: { padding: '16px 8px' },
    },
    {
      title: 'Status',
      field: 'status',
      headerStyle: { color: Text.primary },
      sorting: true,
      width: '120px',
      render: (rowData) => capitalize(rowData.serviceStatus?.name, 'N/A'),
      cellStyle: { padding: '16px 8px' },
    },
    {
      title: 'Name',
      field: 'name',
      headerStyle: { color: Text.primary },
      sorting: true,
      width: '15%',
      render: (rowData) => capitalize(rowData.name, 'N/A'),
      cellStyle: { padding: '16px 8px' },
    },
    {
      title: 'Country',
      field: 'countryId',
      headerStyle: { color: Text.primary },
      sorting: true,
      render: (rowData) => {
        // Extract countryIso from prices
        const countryIsos = rowData.servicePrices
          ?.map((price: any) => price.country?.countryIso)
          ?.filter((iso: string | undefined) => iso)
          ?.sort()
          ?.reverse()
          ?.join(' + ');
        return countryIsos || 'N/A';
      },
      cellStyle: { padding: '16px 8px' },
    },
  ];

  // Dynamically generate price columns
  const priceColumns: Column<any>[] = countries?.map((country: any) => ({
    title: `Price ${country.countryIso}`,
    field: `price${country.countryIso}`,
    headerStyle: { color: Text.primary },
    sorting: true,
    render: (rowData: any) => {
      const price = rowData.servicePrices?.find((p: any) => p.country?.countryIso === country.countryIso);
      return price ? currencySign(country.countryIso, price.pricePerUnit) : 'N/A';
    },
    cellStyle: { padding: '0px 5px 0px 0px' },
  }));

  // Add remaining static columns
  const staticColumns: Column<any>[] = [
    {
      title: 'Date Modified',
      field: 'updatedOn',
      headerStyle: { color: Text.primary },
      sorting: true,
      render: (rowData) => formatDateTime(rowData.updatedOn, false, false, 'N/A'),
      cellStyle: { padding: '16px 8px' },
    },
    {
      title: '',
      field: 'actions',
      removable: false,
      width: '100px',
      sorting: false,
      cellStyle: { padding: '16px 8px' },
    },
  ];

  // Combine all columns
  return [...baseColumns, ...priceColumns, ...staticColumns];
};

export { getServiceTableColumns };